var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 17.721,
    viewBox: "0 0 19.5 17.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Arrow_18123",
    transform: "translate(33.25 -55.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45534",
    "data-name": "Group 45534",
    transform: "translate(-33 56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70632",
    "data-name": "Path 70632",
    d: "M30.4,34.031a1.246,1.246,0,0,1,0,1.762l-5.133,5.134H38.76a1.246,1.246,0,1,1,0,2.492H25.266l5.251,5.251a1.246,1.246,0,0,1-1.762,1.762l-7.143-7.144a1.224,1.224,0,0,1-.1-.116,1.243,1.243,0,0,1-.028-1.977l.018-.02,7.143-7.143A1.246,1.246,0,0,1,30.4,34.031Z",
    transform: "translate(-21.006 -33.667)",
    fill: "#202124",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackArrow);
export default __webpack_public_path__ + "static/media/icon-back-arrow.76f7964c.svg";
export { ForwardRef as ReactComponent };